import React, { useState, useEffect, useCallback } from "react";
import "../../../Styles.css";
import "../../../reports/reports.css";
import "../../../../../ui-styles/contentHeading/contentHeading.css";
import "../../../../../ui-styles/search/Search.css";
import "../../../../../ui-styles/inlineLink/inlineLinkIcon.css";
import Button from "../../../../../lib/ui/buttons/Button";
import Loader from "../../../../../lib/ui/loader/Loader";
import "../../../../common/bookAppointment/BookAppointments.css";
import { getUsers, getAllAdmins, getallClinics, clinicUserReport } from "../../../../../actions/users";
import CertificateFileView from "../../../../doctor/doctorProfile/certificateFileView";
// import DropDownSm from "../../../../../lib/ui/dropdown/DropdownSm";
import NoData from "../../../../../lib/ui/nodata/NoData";
import { Link } from "react-router-dom";
import SlideInDoctorProfile from "./DocProfileSlide";
import DoctorListItem from "./DoctorListItem";
import DropDown from "../../../../../lib/ui/dropdown/Dropdown";
import { useHistory } from "react-router-dom";
// import TotalDoctors from "../../../dashboard/components/TotalDoctorsCard";
import { API } from "aws-amplify";
import { CiFilter } from "react-icons/ci";
import { BiFilterAlt } from "react-icons/bi";
import { IconButton, Menu, MenuItem } from "@material-ui/core";
// const drop = [{ label: "10", value: "10" }, { label: "50", value: "50" }, { label: "100", value: "100" }]

const DoctorList = (props) => {
    const { l, role, userId } = props;
    const history = useHistory();
    const [open, setOpen] = useState(false);
    const [data, setData] = useState({});
    const [doctors, setDoctors] = useState([]);
    const [loading, setLoading] = useState(true);
    const [query, setQuery] = useState("");
    const [uploadView, setUploadView] = useState(null)
    const [admins, setAdmins] = useState([]);
    const [clinics, setClinics] = useState([]);
    const [adminId, setAdminId] = useState("");
    const [clinicId, setClinicId] = useState("");

    // const [endCount,setEndCount] =  useState(10)
    const [totalDoctors, setTotalDoctors] = useState(0);
    let rowsPerPage = 10;
    const [skip, setSkip] = useState(0);
    const [anchorEl, setAnchorEl] = useState(null);
    const [filter, setFilter] = useState("All");
    const [hoveredItem, setHoveredItem] = useState(null);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget); 
        // loadDoctors(null, adminId, clinicId, filter);
    };

    const handleClose = (selectedFilter) => {
        setAnchorEl(null); 
        if (selectedFilter) {
            setFilter(selectedFilter); 
            setSkip(0); 
            loadDoctors(null, adminId, clinicId, selectedFilter);
        }
    };
    useEffect(() => {
        if (skip === 0) {
            clinicUserReport("doctor")
                .then((res) => {
                    if (res.status) {
                        //setUsersReports({ ...res.data });
                        setTotalDoctors(res.data.totalDoctorCount);
                    } else {
                        setTotalDoctors(0);
                    }
                    // setLoading(false);
                })
                .catch((err) => {
                    // setLoading(false);
                    setTotalDoctors(0);
                    console.log("err ==== ", err);
                });
        }
    }, [skip]);

    useEffect(() => {
        if (role === "SA") {
            getAllAdmins()
                .then((res) => {
                    let _admins = [
                        {
                            value: "",
                            label: l.select_admin,
                        },
                    ];
                    res.data.forEach((ad) => {
                        _admins.push({
                            label: ad.companyName,
                            value: ad.userId,
                        });
                    });
                    setAdmins(_admins);
                })
                .catch((err) => {
                    console.log("err in all admin ==== ", err);
                });
        } else if (role === "CA") {
            setAdminId(userId);
        }
    }, [role, userId]);

    useEffect(() => {
        // if (adminId !== '') {
        // let query = `adminId=${adminId}`;
        if (role === "CA" || role === "SA") {
            let query = `adminId=${adminId}`;
            getallClinics(query)
                .then((res) => {
                    if (res.status) {
                        let _clinics = [
                            {
                                value: "",
                                label: l.select_clinic,
                            },
                        ];
                        res.data.forEach((clinic) => {
                            _clinics.push({
                                label: clinic.clinicName,
                                value: clinic.userId,
                            });
                        });
                        setClinics(_clinics);
                    }
                })
                .catch((err) => {
                    console.log("err ==== ", err);
                    setClinics([
                        {
                            value: "",
                            label: l.select_clinic,
                        },
                    ]);
                });
        }
        // } else {
        //     setClinics([{
        //         value: "",
        //         label: l.select_clinic
        //     }]);
        // }
    }, [role]);

    const loadDoctors = useCallback(
        (token, adminid, clinicid,status) => {
            setLoading(true);
            let _s = query && query !== "" ? `&searchKey=${query.toLowerCase()}` : "";
            _s += role === "C" ? `&clinicId=${userId}` : "";

            // _s += adminid && adminid !== '' ? `&adminId=${adminid}` : '';
            _s += clinicid && clinicid !== "" ? `&clinicId=${clinicid}` : "";
            _s += status && status !== "All" ? `&status=${status}` : "";
            getUsers("doctor", _s, token, rowsPerPage, skip)
                .then((res) => {
                    if (res && res.data.length > 0) {
                        setDoctors([...res.data]);
                        // setnextToken(res.token ? res.token : null);
                    } else {
                        // setnextToken(null);
                        setDoctors([]);
                    }
                    setLoading(false);
                })
                .catch((err) => {
                    console.log("err in get doctors === ", err);
                    setDoctors([]);
                    // setnextToken(null);
                    // setprevToken([]);
                    if (API.isCancel(err)) {
                        console.log("API is canceled................");
                    } else {
                        setLoading(false);
                    }
                });
        },
        [query, skip]
    );

    useEffect(() => {
        if (query.length > 1 || query.length == 0) {
            adminId !== "" || clinicId !== "" ? loadDoctors(null, adminId, clinicId) : loadDoctors();
        }
    }, [query, skip]);

    const handleNext = () => {
        if (totalDoctors > (skip + 1) * rowsPerPage) {
            setSkip((prev) => prev + 1);
        }
    };

    // console.log(nextToken);

    const handlePrevious = () => {
        if (skip > 0) {
            setSkip((prev) => prev - 1);
        }
    };

    const handleSlide = () => {
        setOpen((prevState) => !prevState);
    };

    const handleProfileSlide = useCallback((data) => {
        setData(data);
        setOpen((prevState) => (prevState ? prevState : !prevState));
    }, []);

    useEffect(() => {
        if (adminId === "" && clinicId === "" && (role === "CA" || role === "SA")) {
            loadDoctors();
        }
    }, [adminId, clinicId, role]);

    const handleApply = () => {
        if (adminId !== "" || clinicId !== "") {
            loadDoctors(null, adminId, clinicId);
        }
    };


    const handleCloseFile = () => {
        setUploadView(null)
    }

    const handleClear = () => {
        setAdminId("");
        setClinicId("");
    };

    const handleNew = (e) => {
        e.preventDefault();
        let path = role === "CA" || role === "SA" ? "/admin-createusers?dId" : "/clinic-createusers?dId";
        history.push(path);
    };

    return (
        <div className="">
            <div className="listActionBlock">
                <div className="searchCntnr">
                    <div className="searchBox searchFull">
                        <div className="searchForm">
                            <input
                                className="textbox"
                                type="text"
                                placeholder={l.plc_search}
                                value={query}
                                onChange={(e) => setQuery(e.target.value)}
                            />
                        </div>
                    </div>
                </div>
                <div className="inlineItemContainer">
                    <div className="inlineItemGroup">
                        {/* {doctors && doctors.length > 0 && <Button size="sm" className="btn" type="outLine"
                            label={
                                <div className="alignCenter">
                                    <div className="imgIcon Xs"><img className="img primary" src="/images/icons/export.png" alt="icon" /></div>
                                    <span>{l.export}</span>
                                </div>} />} */}
                        <div>
                            {/* Filter Icon */}
                            <div
                                onClick={handleClick}
                                className="alignCenter justifyCenter brdrRadius cursorPointer"
                                style={{ background: "#23A4C41A", height: "31px", width: "31px", border: "1px solid #23A4C4" }}
                            >
                                <BiFilterAlt style={{ color: "#23A4C4", fontSize: "16px" }} />
                            </div>
                            <Menu
                                anchorEl={anchorEl}
                                keepMounted
                                open={Boolean(anchorEl)}
                                onClose={handleClose}
                                getContentAnchorEl={null}
                                anchorOrigin={{
                                    vertical: "bottom",
                                    horizontal: "center",
                                }}
                                transformOrigin={{
                                    vertical: "top",
                                    horizontal: "center",
                                }}
                                PaperProps={{
                                    style: {
                                        borderRadius: "8px",
                                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                                    },
                                }}
                            >
                                {["All", "approved", "rejected", "pending"].map((item, index) => (
                                    <MenuItem
                                        key={index}
                                        onClick={() => handleClose(item)}                
                                        onMouseEnter={() => setHoveredItem(index)}
                                        onMouseLeave={() => setHoveredItem(null)}
                                        style={{
                                            backgroundColor: hoveredItem === index ? "#23A4C4" : "#ffffff",
                                            color: hoveredItem === index ? "#ffffff" : "#23A4C4",
                                            borderRadius: "4px",
                                            margin: "4px 8px",
                                            transition: "background-color 0.2s ease, color 0.2s ease",
                                        }}
                                    >
                                        {item}
                                    </MenuItem>
                                ))}
                            </Menu>
                        </div>
                        {doctors && doctors.length > 0 && (
                            <Link
                                className="inlineLink Sm"
                                to={role === "CA" || role === "SA" ? "/admin-createusers?dId" : "/clinic-createusers?dId"}
                            >
                                <span className="txtPlus">{l.new_doc}</span>
                            </Link>
                        )}
                    </div>
                </div>
            </div>
            <div className="rprtAtnRow flexWrap">
                <div className="halfRow">
                    {/* <span className="spanTxt">{l.show} {doctors.length + '/' + `${display}`}</span> */}
                    <span className="spanTxt">
                        {l.showing} {skip * rowsPerPage} -{" "}
                        {totalDoctors > (skip + 1) * rowsPerPage ? (skip + 1) * rowsPerPage : totalDoctors} of {totalDoctors} {l.entries}
                    </span>
                    {/* <DropDownSm
                        placeholder="10"
                        items={drop}
                        value={display}
                        onChange={(e) => { setDisplay(e.target.value); }}
                        size="smallSize"
                    /> */}
                </div>
                <div className="halfRow makeFull">
                    <div className="webFltr">
                        {role === "SA" && (
                            <div className="webFltrItem">
                                <DropDown
                                    placeholder={l.ass_admin}
                                    items={admins}
                                    value={adminId}
                                    onChange={(e) => setAdminId(e.target.value)}
                                    size="fullWidth"
                                />
                            </div>
                        )}

                        {(role === "SA" || role === "CA") && (
                            <div className="webFltrItem">
                                <DropDown
                                    placeholder={l.ass_clinic}
                                    items={clinics}
                                    value={clinicId}
                                    onChange={(e) => setClinicId(e.target.value)}
                                    size="fullWidth"
                                />
                            </div>
                        )}
                        {(role === "SA" || role === "CA") && (
                            <div className="webFltrItem cardFlex0">
                                {clinicId !== "" && (
                                    <Button label={l.clear} type="outLine" size="md" growOne="growOne" onClick={handleClear} />
                                )}
                                <Button label={l.apply} type="primary" size="md" growOne="growOne" onClick={handleApply} />
                            </div>
                        )}
                    </div>
                    {/* {role === "SA" && <DropDown
                        placeholder={l.ass_admin}
                        items={admins}
                        value={adminId}
                        onChange={(e) => setAdminId(e.target.value)}
                    />}
                    {(role === "SA" || role === "CA") && <DropDown
                        placeholder={l.ass_clinic}
                        items={clinics}
                        value={clinicId}
                        onChange={(e) => setClinicId(e.target.value)}
                    />} */}
                </div>
                <div className="halfRow">
                    <div className="prevNxtBox">
                        <div className="prevBtn" disabled={skip && skip * rowsPerPage <= 0} onClick={handlePrevious}>
                            <span className={skip && skip * rowsPerPage > 0 ? "activeTxt active" : "activeTxt inactive"}>{l.previous}</span>
                        </div>
                        <div className="nxtBtn" onClick={handleNext}>
                            <span className={(skip + 1) * rowsPerPage >= totalDoctors ? "activeTxt inactive" : "activeTxt active"}>
                                {" "}
                                {l.next}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <ul className="cntcListGroup pos-rel">
                {loading && <Loader />}
                {!loading && doctors.length > 0
                    ? doctors.map((doctorItem) => (
                          <DoctorListItem
                              data={doctorItem}
                              key={doctorItem.userId}
                              reloadData={loadDoctors}
                              role={role}
                              handleSlide={handleProfileSlide}
                          />
                      ))
                    : !loading && (
                          <NoData
                              src="/images/icons/pending-new.png"
                              label={l.no_data}
                              btnAction={true}
                              btnLabel={l.new_doc}
                              handleButton={handleNew}
                          />
                      )}
            </ul>
            {open && <SlideInDoctorProfile open={open} closeSlide={handleSlide} data={data} setDoctors={setDoctors} setUploadView={setUploadView} />}
            {uploadView && (
                <CertificateFileView 
                    data={uploadView}
                    handleClose={handleCloseFile}
                />
            )}
        </div>
    );
};
export default DoctorList;
